import { render, staticRenderFns } from "./GoalNavigation.vue?vue&type=template&id=6852a2fd&scoped=true"
import script from "./GoalNavigation.vue?vue&type=script&lang=ts"
export * from "./GoalNavigation.vue?vue&type=script&lang=ts"
import style0 from "./GoalNavigation.vue?vue&type=style&index=0&id=6852a2fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6852a2fd",
  null
  
)

export default component.exports